import api from 'api';
import Menu from 'records/Menu';

export const MENU_ASYNC_ACTION_START = 'MENU_ASYNC_ACTION_START';
export const MENU_ASYNC_ACTION_ERROR = 'MENU_ASYNC_ACTION_ERROR';
export const MENU_ASYNC_UPDATE_ACTION_SUCCESS = 'MENU_ASYNC_UPDATE_ACTION_SUCCESS';
export const MENU_UPDATE_ACTION_SUCCESS = 'MENU_UPDATE_ACTION_SUCCESS';
export const MENU_ARCHIVE_ACTION_SUCCESS = 'MENU_ARCHIVE_ACTION_SUCCESS';
export const MENU_DUPLICATE_ACTION_SUCCESS = 'MENU_DUPLICATE_ACTION_SUCCESS';
export const MENU_RESET_STATE = 'MENU_RESET_STATE';
export const MENU_ASYNC_UPDATE_PARTIAL_ACTION_SUCCESS = 'MENU_ASYNC_UPDATE_PARTIAL_ACTION_SUCCESS';

function menuAsyncActionStart() {
  return {
    type: MENU_ASYNC_ACTION_START,
  };
}

function menuAsyncActionError(error) {
  return {
    type: MENU_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuAsyncArchiveSuccess() {
  return {
    type: MENU_ARCHIVE_ACTION_SUCCESS,
  };
}

function menuAsyncDuplicateSuccess() {
  return {
    type: MENU_DUPLICATE_ACTION_SUCCESS,
  };
}

function menuAsyncUpdateSuccess(data) {
  return {
    type: MENU_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function menuAsyncUpdatePartialSuccess(data) {
  return {
    type: MENU_ASYNC_UPDATE_PARTIAL_ACTION_SUCCESS,
    data,
  };
}

export function resetMenuState() {
  return {
    type: MENU_RESET_STATE,
  };
}

export function updateMenu(data) {
  return {
    type: MENU_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function createMenuAsync(menu) {
  return (dispatch, getState) => {
    dispatch(menuAsyncActionStart());
    return api.request('menu', 'post', menu)
    .then((data) => {
      dispatch(menuAsyncUpdateSuccess(data));
      return new Menu(data);
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to save menu'));
      throw (err);
    });
  };
}

export function updateMenuAsync(menu) {
  return (dispatch, getState) => {
    dispatch(menuAsyncActionStart());
    return api.request('menu', 'put', menu)
    .then((data) => {
      dispatch(menuAsyncUpdateSuccess(data));
      return new Menu(data);
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to save menu'));
      throw (err);
    });
  };
}

export function archiveMenuAsync(id) {
  return (dispatch, getState) => {
    
    return api.request(`menu/archive/${ id }`, 'post')
    .then((data) => {
      dispatch(menuAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to archive menu'));
      throw (err);
    });
  };
}

export function duplicateMenuAsync(id) {
  return (dispatch, getState) => {
    dispatch(menuAsyncActionStart());
    return api.request(`menu/duplicateMenu?id=${ id }`, 'post')
    .then((data) => {
      //console.log('Duplicate selected menu successfully' + JSON.stringify(data));
      dispatch(menuAsyncDuplicateSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to duplicate menu'));
      throw (err);
    });
  };
}

export function restoreArchiveMenuAsync(id) {
  return (dispatch, getState) => {
    
    return api.request(`menu/restoreArchive/${ id }`, 'post')
    .then((data) => {
      dispatch(menuAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to restore archived menu'));
      throw (err);
    });
  };
}

export function getMenuAsync(id) {
  return (dispatch, getState) => {
    dispatch(menuAsyncActionStart());
    return api.request(`menu/${ id }`, 'get')
    .then((data) => {
      dispatch(menuAsyncUpdateSuccess(data));
      return new Menu(data);
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to get menu'));
      throw (err);
    });
  };
}

export function updateMenuVisibilityAsync(menuId, visible, originalVisibility, confirmChange) {
  return (dispatch, getState) => {
    

    return api.request(`menu/${ menuId }/visibility/${ visible }?confirmChange=${ confirmChange }`, 'put')
    .then((data) => {
      const visibleData = { visible };
      dispatch(menuAsyncUpdatePartialSuccess(visibleData));
      return data;
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to update menu visibility'));
      throw (err);
    });
  };
}

export function unlockMenu(id) {
  return (dispatch, getState) => {
    
    return api.request(`menu/unlock/${ id }`, 'put')
    .then(() => {
      return true;
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to unlock menu status'));
      throw (err);
    });
  };
}

export function checkIfMenuLocked(id) {
  return (dispatch, getState) => {
    
    return api.request(`menu/lock/${ id }`, 'get')
    .then(data => {
      return data;
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to check menu lock status'));
      throw (err);
    });
  };
}

export function createMenuFromExcel(file, locationId) {
  return (dispatch, getState) => {
    dispatch(menuAsyncActionStart());
    return api.request(`menu/excelUpload?locationId=${ locationId }`, 'post', file, api.contentTypes.form)
    .then((data) => {
      dispatch((menuAsyncUpdateSuccess(data)));
      return data;
    })
    .catch((err) => {
      dispatch(menuAsyncActionError('Unable to create menu from excel'));
      throw (err);
    });
  };
}
